// src/routes/ExpenseRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';
import ManageExpensesPage from '../pages/expenses/ManageExpensesPage';

const ExpenseRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PermissionRoute requiredPermission="view_all_expenses">
            <ManageExpensesPage />
          </PermissionRoute>
        }
      />
    </Routes>
  );
};

export default ExpenseRoutes;
